<template>
  <b-modal
    ref="semContratante"
    title="Dados para o financeiro"
    size="xl"
    :dialog-class="'alteracao-tamanho-contratante'"
    :modal-class="'center-modal-contratante'"
    no-close-on-backdrop
    no-close-on-esc
    @hide="fechado"
  >
    <div
      v-if="showAlteracao"
      class="row"
      style="justify-content: end;"
    >
      <div
        class="col-2"
        style="text-align: end;"
      >
        <b-btn
          v-b-tooltip.hover
          variant="none"
          title="Alterar"
          class="btn-outline-primary btn-none rounded-pill icone-acao mr-50"
          @click="alterarDados"
        ><feather-icon icon="EditIcon" /></b-btn>
        <info-checklist
          :item-id="dadosContratante && dadosContratante.id ? dadosContratante.id.toString() : '0'"
          :item="dadosContratante"
        />
      </div>
    </div>
    <validation-observer ref="validacao">
      <div class="row">
        <div class="col-2">
          <b-form-group label="Tipo inscrição">
            <b-select
              ref="tipoInscricao"
              v-model="dadosContratante.tipoInscricaoEmpresa"
              :options="['CNPJ','CPF']"
              :disabled="!alterarInformacao"
              @change="limparDeterminadosCampos"
            />
          </b-form-group>
        </div>
        <div class="col-3">
          <b-form-group label="Informe a inscrição">
            <validation-provider
              #default="{ errors }"
              :rules="'required'"
              :name="'Inscrição'"
            >
              <b-input-group>
                <masked-input
                  ref="cadastroFederal"
                  v-model="dadosContratante.inscricao"
                  :mask="mascaraCadFederal"
                  class="form-control"
                  :disabled="!alterarInformacao"
                  @change="dadosContrante.buscado = false"
                />
                <b-input-group-append>
                  <b-button
                    v-b-tooltip.hover
                    title="Busca dados"
                    variant="primary"
                    :disabled="!alterarInformacao"
                    @click="buscarDados(dadosContratante)"
                  >
                    <feather-icon
                      v-if="dadosContratante.buscado"
                      icon="CheckIcon"
                    />
                    <feather-icon
                      v-else
                      icon="SearchIcon"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <small
                v-if="dadosContratante.erroNavegacao"
                class="text-danger"
              >Não foi possível concluir a busca de dados na RFB, verifique o CNPJ informado e tente novamente!</small>
              <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </div>
        <div class="col-7">
          <b-form-group :label="dadosContratante.tipoInscricaoEmpresa === 'CPF' ? 'Nome' : 'Razão social'">
            <validation-provider
              #default="{ errors }"
              :rules="'required'"
              :name="dadosContratante.tipoInscricaoEmpresa === 'CPF' ? 'Nome' : 'Razão social'"
            >
              <b-input
                v-model="dadosContratante.nomeRazaoSocial"
                :disabled="!alterarInformacao"
              />
              <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </div>
      </div>

      <div>
        <div
          v-if="dadosContratante.tipoInscricaoEmpresa === 'CNPJ'"
          class="row mt-50"
        >
          <div class="col">
            <b-form-group label="Nome fantasia">
              <b-input
                v-model="dadosContratante.nomeFantasia"
                :disabled="!alterarInformacao"
              />
            </b-form-group>
          </div>
        </div>

        <div
          v-if="dadosContratante.tipoInscricaoEmpresa === 'CNPJ'"
          class="row mt-50"
        >
          <div
            class="col-5"
          >
            <legend class="col-form-label pt-0">
              Optante pelo Simples Nacional
            </legend>
            <validation-provider
              #default="{ errors }"
              :rules="'required'"
              :name="'Simples Nacional'"
            >
              <b-select
                v-model="dadosContratante.simplesNacional"
                :disabled="!alterarInformacao"
                name="filtroDataPesquisa"
                class="search-items"
              >
                <option
                  v-for="(cert, index) in simplesNacional"
                  :key="index"
                  :value="cert.value"
                >{{ cert.text }}
                </option>
              </b-select>
              <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
            </validation-provider>
          </div>
          <div class="col-7">
            <telefone-celular
              :value="dadosContratante.telefoneContato"
              :disabled="!alterarInformacao"
            />
          </div>
        </div>
      </div>

      <div class="row mt-50">
        <div class="col">
          <email-input
            :value="dadosContratante.emailsBoletosNFs"
            :require="true"
            :disabled="!alterarInformacao"
            @input="adicionarEmail($event)"
          />
        </div>
        <div
          v-if="dadosContratante.tipoInscricaoEmpresa === 'CPF'"
          class="col-5"
        >
          <telefone-celular
            :value="dadosContratante.telefoneContato"
            :disabled="!alterarInformacao"
          />
        </div>
      </div>

      <div :class="'row mt-1'">
        <div class="col-3">
          <cep-input
            :value="dadosContratante.cep"
            :disable="!alterarInformacao"
            @atualizar-endereco="enderecoBuscado"
          />
        </div>
        <b-form-group
          label="Endereço"
          class="col-md-6"
        >
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'endereço'"
          >
            <b-form-input
              v-model="dadosContratante.logradouro"
              :disabled="!alterarInformacao"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          label="Número"
          class="col-md-3"
        >
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'Número'"
          >
            <b-form-input
              v-model="dadosContratante.numero"
              :disabled="!alterarInformacao"
              @keypress="isNumber($event)"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>
      </div>

      <div class="row mt-50">
        <b-form-group
          label="Complemento"
          class="col-md-3"
        >
          <b-form-input
            v-model="dadosContratante.complemento"
            :disabled="!alterarInformacao"
          />
        </b-form-group>
        <b-form-group
          label="Bairro"
          class="col-md-4"
        >
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'Bairro'"
          >
            <b-form-input
              v-model="dadosContratante.bairro"
              :disabled="!alterarInformacao"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>
        <b-col cols="3">
          <legend class="col-form-label pt-0">
            Cidade
          </legend>
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'Cidade'"
          >
            <municipio-select
              v-model="dadosContratante.cidade"
              class="desabilitar"
              :disabled="!alterarInformacao"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </b-col>
        <b-col cols="2">
          <legend class="col-form-label pt-0">
            Estado
          </legend>
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'Estado'"
          >
            <estado-select
              v-model="dadosContratante.uf"
              class="desabilitar"
              :disabled="!alterarInformacao"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </b-col>
      </div>
      <div
        class="row mt-50"
      >
        <b-col cols="7">
          <b-form-group label="ID Omie">
            <b-input
              v-model="dadosContratante.idOmie"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
        <b-col cols="5">
          <b-form-group label="Data de Cadastro na Omie">
            <b-input
              v-model="dadosContratante.dataCadastroOmie"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
      </div>
    </validation-observer>
    <template #modal-footer>
      <div class="row">
        <div class="col">
          <b-btn
            variant="primary"
            :disabled="!alterarInformacao"
            @click="salvarAlteracao"
          >
            Salvar alteração
          </b-btn>
        </div>
        <div class="col-auto">
          <b-btn
            variant="danger"
            @click="$refs.semContratante.hide()"
          >
            Cancelar
          </b-btn>
        </div>
      </div>
    </template>
    <modal-justificativa
      id="'modalJustificativa'"
      :ref="'modalJustificativa'"
      :texto-apresentacao="'Informe o motivo da alteração'"
      @cancelar="cancelar()"
      @confirmar="confirmar($event)"
    />
  </b-modal>
</template>

<style lang="scss">
.alteracao-tamanho-contratante {
  width: 1100px !important;
}

.center-modal-contratante {
  display: flex !important;
  justify-content: center !important;
}

.desabilitar .vs--disabled .vs__dropdown-toggle,
.desabilitar .vs--disabled .vs__search {
  background-color: #efefef;
}

</style>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'

export default {
  name: 'DadosContratanteInterno',
  components: {
    ValidationProvider,
    ValidationObserver,
    EstadoSelect: () => import('@/shared/components/estado-select/EstadoSelect.vue'),
    TelefoneCelular: () => import('@/shared/components/telefone-celular/TelefoneCelular.vue'),
    MunicipioSelect: () => import('@/shared/components/municipio-select/MunicipioSelect.vue'),
    InfoChecklist: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/checklist-proposta/shared/components/InfoChecklist.vue'),
    ModalJustificativa: () => import('@/shared/components/modal-justificativa/ModalJustificativa.vue'),
    EmailInput: () => import('@/@pilar/components/email-input/EmailInput.vue'),
    CepInput: () => import('@/@pilar/components/cep-input/CepInput.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    propostaId: {
      type: Number,
      default: 0,
    },
    showAlteracao: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dadosContratante: {
        tipoInscricaoEmpresa: 'CPF',
        inscricao: null,
        emailsBoletosNFs: [],
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
        },
        buscado: true,
      },
      original: {
        buscado: true,
      },
      invalidTags: [],
      duplicateTags: [],
      alterarInformacao: false,
      simplesNacional: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ],
    }
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.dadosContratante = { ...this.value }
        this.original = value
        this.$set(this.dadosContratante, 'buscado', true)
        if (!this.showAlteracao) {
          this.alterarInformacao = true
        }
      }
    },
    showAlteracao(value, oldValue) {
      if (value !== oldValue) {
        this.alterarInformacao = !value
      }
    },
  },
  created() {
    this.dadosContratante = { ...this.value }
    this.original = this.value
    if (!this.showAlteracao) {
      this.alterarInformacao = true
    }
  },
  methods: {
    adicionarEmail(value) {
      this.dadosContratante.emailsBoletosNFs = value
    },
    show() {
      this.$refs.semContratante.show()
    },
    mascaraCadFederal() {
      if (this.dadosContratante.tipoInscricaoEmpresa === 'CPF') {
        return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
      }
      return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    mudarParaLowerCase(value) {
      const emails = []
      value.forEach(each => emails.push(each.toLowerCase()))
      this.dadosContratante.emailsBoletosNFs = emails
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes('field is required')) {
        return erro.replace('The', '').replace('field is required', 'é um campo obrigatório')
      }
      return erro
    },
    salvarAlteracao() {
      this.$refs.validacao.validate()
        .then(result => {
          if (result) {
            if (!this.showAlteracao) {
              this.$emit('aprovar', this.dadosContratante)
              this.$refs.semContratante.hide()
            } else {
              api.atualizaPropostaContratante(this.dadosContratante)
                .then(() => {
                  this.original = this.dadosContratante
                  this.$sucesso('Dados do financeiro alterado com sucesso!')
                  this.$refs.semContratante.hide()
                })
                .catch(err => {
                  this.$erro(err.response.data.message || err.message)
                  throw err
                })
            }
          } else {
            this.$erro('Preencha os campos obrigatórios!')
          }
        })
    },
    enderecoBuscado(value) {
      this.$set(this.dadosContratante, 'logradouro', value.logradouro)
      this.$set(this.dadosContratante, 'bairro', value.bairro)
      this.$set(this.dadosContratante, 'complemento', value.complemento)
      this.$set(this.dadosContratante, 'uf', value.uf)
      this.$set(this.dadosContratante, 'cidade', value.cidade)
      this.$set(this.dadosContratante, 'cep', value.cep)
    },
    // eslint-disable-next-line consistent-return
    isNumber(e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[0-9]+$/.test(char)) return true
      e.preventDefault()
    },
    alterarDados() {
      this.$refs.modalJustificativa.show()
    },
    cancelar() {
      this.$refs.modalJustificativa.hide()
    },
    confirmar(mensagem) {
      const justSemEspaco = mensagem.replace(/\s+/g, '')
      if (!mensagem || justSemEspaco.length < 10) {
        this.$erro(!mensagem ? 'A justificativa para a alteração é obrigatória.' : 'A justificativa deve ter no mínimo 10 caracteres!')
      } else {
        this.dadosContratante.justificativa = mensagem
        this.alterarInformacao = true
        this.$refs.modalJustificativa.hide()
      }
    },
    buscarDados(dados) {
      this.dadosContratante.erroNavegacao = false
      api.buscaPropostaContratante(dados)
        .then(payload => {
          if (payload.data) {
            const { data } = payload
            this.dadosContratante = data
            if (this.original && this.original.id > 0) {
              this.dadosContratante.id = this.original.id
            }
            if (!this.dadosContratante.emailsBoletosNFs || (this.dadosContratante.emailsBoletosNFs && this.dadosContratante.emailsBoletosNFs.length === 0)) {
              this.dadosContratante.emailsBoletosNFs = []
            }
          } else if (dados.tipoInscricaoEmpresa === 'CPF') {
            this.$erro('CPF não encontrado em nossa base de dados, preencha os campos manualmente.')
          }
        })
        .catch(err => {
          this.$erro(err.response.data.message || err.message)
          throw err
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    limparDeterminadosCampos(value) {
      this.dadosContratante = {
        nomeRazaoSocial: null,
        nomeFantasia: null,
        inscricao: null,
        emailsBoletosNFs: [],
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
        },
      }
      this.$set(this.dadosContratante, 'tipoInscricaoEmpresa', value)
    },
    fechado() {
      this.dadosContratante = { ...this.original }
      this.$set(this.dadosContratante, 'tipoInscricaoEmpresa', this.original.tipoInscricaoEmpresa)
      if (this.showAlteracao) {
        this.alterarInformacao = false
      }
    },
  },
}
</script>
